import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.6_@vue+compiler-sfc@3.5.17_eslint@9.30.1_rollup@4.44.2_typescript@5.8.3_vite@7.0.2/node_modules/nuxt/dist/pages/runtime/validate.js";
import locale_45global from "/vercel/path0/middleware/locale.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.6_@vue+compiler-sfc@3.5.17_eslint@9.30.1_rollup@4.44.2_typescript@5.8.3_vite@7.0.2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  locale_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}